import React, { useState } from 'react';
import PopularMovieCard from './PopularMovieCard';
import usePopularMovies from '../hooks/usePopularMovies';
import { useSelector } from 'react-redux';
import Navbar from './Navbar';
import Footer from './Footer';

const Home = () => {
  const movie = useSelector(store => store.movie.popularMovie); 
  usePopularMovies();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Rows per page
  const popularMovie = movie || [];

  // Calculate the indices for slicing the data
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = popularMovie.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(popularMovie.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <Navbar />
      <section className="mb-10">
        <div className="mx-auto max-w-sm sm:max-w-sm md:max-w-md lg:max-w-[1211px]">
          <PopularMovieCard movies={currentRows} />
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-center mt-4">
          <nav className="flex items-center space-x-2">
            {/* Previous Button */}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-4 py-2 border rounded-[30px] btn-pagination ${
                currentPage === 1
                  ? 'text-gray-300 border-gray-300 cursor-not-allowed'
                  : 'text-red-500 hover:bg-gray-100 border-gray-400'
              }`}
            >
              Previous
            </button>

            {/* Page Numbers */}
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                className={`px-4 py-2 rounded-[30px] border-pgn ${
                  currentPage === index + 1
                    ? 'bg-red-500 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {index + 1}
              </button>
            ))}

            {/* Next Button */}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 border rounded-[30px] btn-pagination ${
                currentPage === totalPages
                  ? 'text-gray-300 border-gray-300 cursor-not-allowed'
                  : 'text-red-500 hover:bg-gray-100 border-gray-400'
              }`}
            >
              Next
            </button>
          </nav>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default Home;
